module.exports = __webpack_public_path__ + "static/img/shezhi_chongzhi.631828b3.png";